module.exports = __webpack_public_path__ + "static/media/poll.7e78a502.svg";